/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_triange': {
    width: 256,
    height: 288,
    viewBox: '0 0 256 288',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M71 185h185L71 0v185z" _fill="#7ED09E"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M0 288h185L0 103v185z" _fill="#285680"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M71 288h185L71 103v185z" _fill="#FF2F83"/>'
  }
})
